// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"302":"dda52edb","322":"1e188887","378":"ff5584f6","505":"bff71bd5","534":"4e94a2c6","662":"6ad72899","687":"e8862a68","810":"ef4c2d57","932":"115c2fe1"}[chunkId] + ".js";
};